/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bright_Warm_Fox_WarnInputs */

const en_bright_warm_fox_warn = /** @type {(inputs: Bright_Warm_Fox_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No round IDs or date range set — this will match all data.`)
};

const de_bright_warm_fox_warn = /** @type {(inputs: Bright_Warm_Fox_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Runden-IDs oder Zeitraum gesetzt — es werden alle Daten verwendet.`)
};

/**
* | output |
* | --- |
* | "No round IDs or date range set — this will match all data." |
*
* @param {Bright_Warm_Fox_WarnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bright_warm_fox_warn = /** @type {((inputs?: Bright_Warm_Fox_WarnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bright_Warm_Fox_WarnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bright_warm_fox_warn(inputs)
	return de_bright_warm_fox_warn(inputs)
});